const { get } = require('lodash');
const R = require('ramda');

module.exports = function (value) {
  try {
    return R.compose(
      R.join(R.propOr(', ', 'separator')(value)),
      R.filter((value) => value),
      R.map(({ value }) => (value ? value.trim() : value)),
      R.sort((a, b) =>
        a.value.toLowerCase().localeCompare(b.value.toLowerCase())
      ),
      R.filter((r) => r),
      R.propOr([], 'records')
    )(value);
  } catch (err) {
    console.log('[ERROR] Dropdown toString w/ Value', value);
    throw err;
  }
};
